import React from 'react';
import { fetchVariableConfig } from '../helpers/fetchVariableConfig';

const LegendSelector = ({ selectedValue, setSelectedValue, layer, setKey, setVariable, setData, legendConfig}) => {
  
  const handleInputChange = (e) => {
    setSelectedValue(e.target.value);
    fetchVariableConfig( e.target.value )
    .then( data => {         
        setData(data)
        setKey() 
    })
  }

  if (layer !== '') {
    return (
      <>
        <div className="legend-section">
          <div className="legend-label">{ layer }</div>
          {/* <label htmlFor="variable-selector" className="label-variable">Variable:</label> */}
          <select
            id="variable-selector"
            onChange={(e) => handleInputChange(e)}
            className="variable-selector"
            value={selectedValue}
          >
            <option value="" hidden>Seleccionar Variable</option>
            {Object.keys(legendConfig).map((key) => (
              <option key={key} value={key}>{legendConfig[key].label}</option>
            ))}
          </select>
          {/* <LegendContent geoserverUrl={geoserverUrl} layerName={layer} styleName={variable} ></LegendContent> */}
        </div>
      </>
    );
  }
};

export default LegendSelector;
